import { useState } from "react";
import "../../../css/Carousel/MediaCarousel.css";
import { ReactComponent as EnlargeIcon } from "../../../assets/icons/enlarge.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { ReactComponent as ArrowRight } from "../../../assets/icons/Arrow Right.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/icons/Arrow Left.svg";

function MediaCarousel({
  items = [], // [{ id, base64, mimetype?, label?, context? }]
  ariaLabel = "Media carousel",
}) {
  const [i, setI] = useState(0);
  const [isEnlarged, setIsEnlarged] = useState(false);
  const count = items.length;

  if (!count) return null;

  const isVideo = (m) => {
    if (!m) return false;
    if (m.startsWith?.("video")) return true;
    if (m.startsWith?.("data:video")) return true;
    return false;
  };

  const prev = () => setI((p) => (p === 0 ? count - 1 : p - 1));
  const next = () => setI((p) => (p === count - 1 ? 0 : p + 1));
  const onKeyDown = (e) => {
    if (e.key === "ArrowLeft") prev();
    if (e.key === "ArrowRight") next();
    if (e.key === "Escape") setIsEnlarged(false);
  };

  const current = items[i];
  const isCurrentVideo = isVideo(current.mimetype || current.base64 || "");

  return (
    <>
      <div
        className="aml-carousel"
        tabIndex={0}
        onKeyDown={onKeyDown}
        aria-roledescription="carousel"
        aria-label={ariaLabel}
      >
        <div className="number-of-items AML-Text-Body">
          {count >= 1 ? `${i + 1}/${count}` : ""}
        </div>

        <div className="aml-carousel-frame">
          <div
            className="aml-carousel-track"
            style={{
              "--slide-count": count,
              "--active-index": i,
            }}
          >
            {items.map((m, idx) => {
              const video = isVideo(m.mimetype || m.base64 || "");
              return (
                <div key={m.id || idx} className="aml-carousel-slide">
                  {video ? (
                    <video
                      src={m.base64}
                      controls
                      className="aml-carousel-media"
                      title={m.title || m.label || m.context || ""}
                    />
                  ) : (
                    <img
                      src={m.base64}
                      alt={m.label || m.context || m.id || `media-${idx + 1}`}
                      title={m.title || m.label || m.context || ""}
                      className="aml-carousel-media"
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Enlarge button */}
        <EnlargeIcon
          className="aml-carousel-enlarge-icon"
          onClick={() => setIsEnlarged(true)}
        />

        {/* Navigation arrows */}
        {count > 1 && (
          <>
            {/* <button
              type="button"
              onClick={prev}
              aria-label="Previous"
              className="aml-carousel-arrow left"
            >
              ‹
            </button> */}
            <div className="aml-carousel-arrow left">
              <ArrowLeft onClick={prev} aria-label="Previous" />
            </div>
            <div className="aml-carousel-arrow right">
              <ArrowRight onClick={next} aria-label="Next" />
            </div>
            {/* <button
              type="button"
              onClick={next}
              aria-label="Next"
              className="aml-carousel-arrow right"
            >
              ›
            </button> */}
          </>
        )}
      </div>

      {isEnlarged && (
        <div
          className="aml-lightbox-overlay"
          onClick={() => setIsEnlarged(false)}
        >
          {/* Close icon now sits on overlay */}
          <CloseIcon
            className="aml-lightbox-close"
            onClick={() => setIsEnlarged(false)}
          />
          <div
            className="aml-lightbox-content"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            {isCurrentVideo ? (
              <video
                src={current.base64}
                controls
                autoPlay
                className="aml-lightbox-media"
              />
            ) : (
              <img
                src={current.base64}
                alt={current.label || "enlarged-media"}
                className="aml-lightbox-media"
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default MediaCarousel;
